module.exports = __webpack_public_path__ + "img/achievement.de199e63.svg";